module.exports = __webpack_public_path__ + "static/littleWomen2-9835b64fbebd2efd73d5b0aacc978618.jpg";